import { useQuery } from '@tanstack/react-query';
import type { BillingPlanDto } from '@tb/shared';
import { api } from '../api/endpoints';

export interface CustomCodeAccess {
  unlocked: boolean;
  until: string | null;
  fromTrial: boolean;
  priceGram: string | null;
  plans: BillingPlanDto[];
}

export function useCustomCode(): CustomCodeAccess {
  const billing = useQuery({ queryKey: ['billing'], queryFn: () => api.billing.me() });
  const plans = useQuery({
    queryKey: ['plans'],
    queryFn: () => api.billing.plans(),
    staleTime: 5 * 60_000,
  });

  const state = billing.data?.customCode;
  const addOns = (plans.data ?? []).filter((plan) => plan.feature === 'CUSTOM_CODE');

  return {
    unlocked: state?.unlocked ?? true,
    until: state?.until ?? null,
    fromTrial: state?.source === 'TRIAL',
    priceGram: cheapest(addOns),
    plans: addOns,
  };
}

function cheapest(plans: BillingPlanDto[]): string | null {
  let best: BillingPlanDto | null = null;
  for (const plan of plans) {
    if (!best || BigInt(plan.priceNanogram) < BigInt(best.priceNanogram)) best = plan;
  }
  return best?.priceGram ?? null;
}
